import React, { useState } from "react";
import MenuIcon from "@atlaskit/icon/core/menu";
import { Popover } from "antd";

import Button from "@atlaskit/button/new";
import DeleteActionMenuItem from "./DeleteActionMenuItem";
import DuplicateActionMenuItem from "./DuplicateActionMenuItem";
import MoveActionMenuItem from "./MoveActionMenuItem";
import { useEscapeShortcut } from "../../../../../common/utils/keybindings";

const ActionMenu = ({ action }) => {
  const [showActionMenu, setShowActionMenu] = useState(false);

  const handleClickChange = (visible) => {
    setShowActionMenu(visible);
  };

  const onClickCallback = () => {
    setShowActionMenu(false);
  };

  const onEscape = () => {
    if (showActionMenu) {
      setShowActionMenu(false);
    }
  };
  useEscapeShortcut(onEscape);

  const renderContent = () => {
    return (
      <>
        <DeleteActionMenuItem action={action} showParentModal={setShowActionMenu} />
        <br />
        <DuplicateActionMenuItem action={action} onClickCallback={onClickCallback} />
        <br />
        <MoveActionMenuItem action={action} onClickCallback={onClickCallback} />
      </>
    );
  };

  return (
    <div className="ihub-actionmenu-icons">
      <Popover content={renderContent()} title="" trigger="click" open={showActionMenu} onOpenChange={handleClickChange}>
        <Button
          iconBefore={MenuIcon}
          appearance="subtle"
          onClick={() => {
            setShowActionMenu(!showActionMenu);
          }}
        />
      </Popover>
    </div>
  );
};
export default ActionMenu;
